import React from 'react';
import { useUserWellnessHour } from '../hooks/use-user-wellness-hour';
import { InlineFieldEditor } from '../../../components';
import HourLabel from '../../../components/hours/label';
import HourSelector from '../../../components/hours/selector';

export const UserWellnessHour = ({
    userId
}) => {
    const {
        hourId,
        isLoading,
        saveHour,
        isSaving,
        canSave
    } = useUserWellnessHour({ userId});
    
    return (
        <InlineFieldEditor
            onRenderField={({value}) => <HourLabel hourId={value} />}
            onRenderFieldEditor={({value, setValue}) => <HourSelector value={value} onChange={setValue} />}
            isBusy={isLoading || isSaving}
            canSave={canSave}
            onChange={saveHour}
            value={hourId}
        />
    );
};